import { CreatedInterfaces } from 'interfaces';

import { usePostRequest } from 'hooks/utils/usePostRequest';

const resource = 'card-holder-post';

const useCreateCardHolder = (validateIdentification: boolean, validateAddress: boolean) => {
  const [{ data, error, loading }, createCardHolder] = usePostRequest<CreatedInterfaces<typeof resource>>({
    path: `v2/card_holders?identification_validation=${validateIdentification}&validate_address=${validateAddress}`,
  });

  return {
    cardHolder: data,
    createCardHolder,
    isLoading: loading,
    isError: error,
  };
};

export default useCreateCardHolder;
